import { render, staticRenderFns } from "./FailedInvoiceDeliveriesWarning.vue?vue&type=template&id=bd8783ee&scoped=true&"
import script from "./FailedInvoiceDeliveriesWarning.vue?vue&type=script&lang=ts&"
export * from "./FailedInvoiceDeliveriesWarning.vue?vue&type=script&lang=ts&"
import style0 from "./FailedInvoiceDeliveriesWarning.vue?vue&type=style&index=0&id=bd8783ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8783ee",
  null
  
)

export default component.exports